import request from "../../../../../../../service";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {IErrorResponse, IRootState} from "../../../../../../../types";
import {
    deleteBranches, deletedRestoreBranches,
    setBranches, setBranchesRestore,
} from "../store/branchesSlice";
import {IBranchesCreate, IBranchesPayload} from "../types";

const GetBranches = createAsyncThunk(
    "get/branches",
    async (_, {dispatch, rejectWithValue,getState}) => {
        try {
            const response = await request.get("/branches");

            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setBranches({ data: response.data,defaultLanguage }));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const CreateBranches = createAsyncThunk(
    "create/branches",
    async (data: IBranchesCreate, { rejectWithValue}) => {
        try {
            const response = await request.post("/branches", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteBranches = createAsyncThunk(
    "delete/branches",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.delete(`/branches/${id}`);

            dispatch(deleteBranches(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditBranches = createAsyncThunk(
    "edit/branches",
    async (data: IBranchesPayload, { rejectWithValue}) => {
        try {

            const response = await request.put(
                `/branches/${data.id}`,
                data
            );

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteBranches = createAsyncThunk(
    "get/delete/branches",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/branches/deleted-items`);

            dispatch(setBranchesRestore(response.data));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteBranches = createAsyncThunk(
    "restore/delete/branches",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.post(`/branches/restore/${id}`);

            dispatch(deletedRestoreBranches(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetBranches,
    DeleteBranches,
    CreateBranches,
    EditBranches,
    GetDeleteBranches,
    RestoreDeleteBranches
};
